import { UserState } from "store/User/types";
import { create } from "zustand";

export const useUserStore = create<UserState>()((set, get) => ({
  user: null,
  setUser: (user) => set(() => ({ user })),
}));
